const team = [
  {
    id: 1,
    name: "Ibironke Johnson",
    job: "Managing Director",
    image: "Mr Johnson.jpg",
  },
  {
    id: 2,
    name: "Olawale Michael",
    job: "Software Engineer (Backend)",
    image: "micheal.jpg",
  },

  {
    id: 3,
    name: "Idowu Felix",
    job: "Software Engineer (Mobile)",
    image: "felix.jpg",
  },
  {
    id: 4,
    name: "Adaralegbe Ifeoluwa",
    job: "Software Engineer (Web)",
    image: "ifeoluwa.jpg",
  },
  {
    id: 5,
    name: "Olajide Ayomide",
    job: "Software Engineer (Web)",
    image: "ayomide.jpg",
  },
  {
    id: 6,
    name: "Jewoola Favour",
    job: "Software Engineer (Mobile)",
    image: "favour.jpg",
  },
  {
    id: 7,
    name: "Oderinde Elisha",
    job: "Software Engineer (Mobile)",
    image: "elishaa.jpg",
  },
  {
    id: 8,
    name: "Temiloluwa Paul",
    job: "Software Engineer (Web)",
    image: "paul.jpg",
  },

  {
    id: 9,
    name: "Emurotu Paul",
    job: " Data Engineer",
    image: "emurotu.jpg",
  },
  {
    id: 10,
    name: "Ademola Abdullahi",
    job: "Software Engineer (Web)",
    image: "abdullahi.jpg",
  },
  {
    id: 11,
    name: "Mercy Arawole",
    job: "Software Engineer (Web)",
    image: "mercy.jpg",
  },
  {
    id: 12,
    name: "Deborah Ayoola",
    job: "Cybersecurity Analyst",
    image: "ayoola.jpg",
  },
  {
    id: 13,
    name: "Oluwole Odunayo",
    job: "Business Growth Strategist",
    image: "odunayo.jpg",
  },
  {
    id: 14,
    name: "Odewumi Esther",
    job: "Financial Analyst",
    image: "esther.jpg",
  },
  {
    id: 15,
    name: "Okunola Esther",
    job: "People Operations Manager",
    image: "estherokunola.jpg",
  },
  {
    id: 16,
    name: "Olawumi Titilayo",
    job: "Data Scientist",
    image: "titilayo.jpg",
  },
  {
    id: 17,
    name: "Adisa Temitope",
    job: "Product Designer",
    image: "temitope.jpg",
  },
  {
    id: 18,
    name: "Ajao Joshua",
    job: "Data Scientist",
    image: "joshua.jpg",
  },
  {
    id: 19,
    name: "Akintunde Timileyin",
    job: "Product Designer",
    image: "timileyin.jpg",
  },
  {
    id: 20,
    name: "Segun Adebiyi",
    job: "IOT Engineer",
    image: "segun.jpg",
  },
  {
    id: 21,
    name: "Taiwo Mary",
    job: "Digital Marketer",
    image: "mary.jpg",
  },
  {
    id: 22,
    name: "Oyeyemi Feranmi",
    job: "Product Manager",
    image: "feranmi.jpg",
  },
  {
    id: 23,
    name: "Aremu Moses",
    job: "Software Engineer (Mobile)",
    image: "moses.jpg",
  },
  {
    id: 24,
    name: "Adekola Adekolapo",
    job: "Software Engineer (Web)",
    image: "kolapo.jpg",
  },
];

export default team;
